import Configurator from './Components/Configurator.svelte';
const target = document.getElementById('phd_configurator');
const shopify = target.getAttribute('data-shopify');
const erp = target.getAttribute('data-erp');
const props = {shopify, erp};
const configurator = new Configurator({target, props});
export default configurator;